module.exports = __webpack_public_path__ + "images/district_back.1790221230673.png";